/**
 * Sales data as every connector hands it over, before anything is decided
 * about it. Normalizing here is what keeps five very different order APIs from
 * leaking their shape into recognition, review or the dashboard.
 *
 * Money is integer minor units throughout, like the rest of the app.
 */
export const SALES_SITES = ['mlf', 'mff', 'unattributed'];
export const SALES_ORDER_STATES = ['pending', 'open', 'fulfilled', 'cancelled'];
export const SALES_TREATMENTS = ['count_payments', 'count_order_total', 'count_custom', 'exclude'];
export const SALES_PAYMENT_STATES = ['none', 'partial', 'full', 'over'];
/**
 * Per channel type. Each connector phase flips its own `orders` to true; until
 * then the channel reports why it has no sales data rather than showing zeros.
 */
export const SALES_CAPABILITIES = {
    drupal_uc: {
        orders: true,
        unsupportedReason: null,
        recognitionBasis: 'payments',
        fees: 'none',
        incrementalBy: 'updated',
        maxHistoryDays: null,
        backfillWindowDays: 90,
        incrementalOverlapMinutes: 60,
        refreshRecentDays: 120,
        traffic: 'ga4',
    },
    drupal_commerce: {
        orders: true,
        unsupportedReason: null,
        recognitionBasis: 'payments',
        fees: 'none',
        incrementalBy: 'updated',
        maxHistoryDays: null,
        backfillWindowDays: 90,
        incrementalOverlapMinutes: 60,
        refreshRecentDays: 120,
        traffic: 'ga4',
    },
    etsy: {
        orders: true,
        unsupportedReason: null,
        recognitionBasis: 'order_total',
        fees: 'ledger',
        incrementalBy: 'updated',
        maxHistoryDays: null,
        backfillWindowDays: 30,
        incrementalOverlapMinutes: 48 * 60,
        refreshRecentDays: null,
        traffic: 'unavailable',
    },
    ebay: {
        orders: false,
        unsupportedReason: 'eBay order import is not built yet (phase 6b) and needs eBay reconnected',
        recognitionBasis: 'order_total',
        fees: 'with_order',
        incrementalBy: 'updated',
        maxHistoryDays: 730,
        backfillWindowDays: 30,
        incrementalOverlapMinutes: 48 * 60,
        refreshRecentDays: null,
        traffic: 'ebay_traffic',
    },
    amazon: {
        orders: false,
        unsupportedReason: 'Amazon order import is not built yet (phase 6c) and needs new SP-API roles',
        recognitionBasis: 'order_total',
        fees: 'ledger',
        incrementalBy: 'updated',
        maxHistoryDays: null,
        backfillWindowDays: 30,
        incrementalOverlapMinutes: 48 * 60,
        refreshRecentDays: null,
        traffic: 'amazon_sales_traffic',
    },
};
/**
 * Thrown by a connector whose channel cannot export orders yet — typically a
 * bridge module older than the orders endpoint. The sync records the reason
 * and moves on, rather than counting it as a failing import.
 */
export class SalesUnsupportedError extends Error {
    constructor(message) {
        super(message);
        this.name = 'SalesUnsupportedError';
    }
}
export const supportsOrders = (connector) => typeof connector.fetchOrders === 'function';
//# sourceMappingURL=sales-types.js.map